import { AubadeComponent } from "js/front/bootstrap";
import { gsap } from 'gsap';
import { storage, customization } from 'storage';

export class EditProduct extends AubadeComponent{
	constructor(e, b){
		super(e, b);

		this.tuto 			= this.element.querySelector(".fps-edit-tuto");
		this.bgGradient 	= this.element.querySelector(".fps-bg-gradient");
		this.estimation 	= this.element.querySelectorAll(".fps-estimation-container");
		this.available 		= this.element.querySelector(".fps-number-available");
		this.validBtns 		= this.element.querySelectorAll(".fps-validations-btn");

		this.numberEntitiesMobile = this.element.querySelector(".fps-number-entities");
		this.numberProductsMobile = this.element.querySelector(".fps-number-products");

		this.entitySelector 	= this.element.querySelectorAll(".fps-entity-selector");
		this.productSelector 	= this.element.querySelectorAll(".fps-product-selector");

		this.contentDesktop = this.element.querySelector(".fps-content-desktop");

		this.validateBtn = Array.from(this.element.querySelectorAll(".fps-validate"))
		this.cancelBtn   = Array.from(this.element.querySelectorAll(".fps-cancel"))

		this.header 	= document.querySelector('header');
		this.headerC =  this.bootstrap.components.get(document.querySelector("header"));

		this.currentEntity = null;
		this.currentProduct = null;
		this.visible = false;

	}

	init(){
		this.cHeader  = this.components.get(this.header);
		this.cEntitySelectorMobile  = this.components.get(this.entitySelector[0]);
		this.cProductSelectorMobile = this.components.get(this.productSelector[0]);

		this.cEntitySelectorDesktop  = this.components.get(this.entitySelector[1]);
		this.cProductSelectorDesktop = this.components.get(this.productSelector[1]);
	}

	attach() {
		this.validateBtn.forEach(btn => btn.addEventListener('click', this.validate));
		this.cancelBtn.forEach(btn => btn.addEventListener('click', this.cancel));
		this.cEntitySelectorMobile.on('change', this.onEntityChange);
		this.cEntitySelectorDesktop.on('change', this.onEntityChange);
		this.cProductSelectorMobile.on('change', this.onProductChange);
		this.cProductSelectorDesktop.on('change', this.onProductChange);
	}

	detach() {
		this.validateBtn.forEach(btn => btn.removeEventListener('click', this.validate));
		this.cancelBtn.forEach(btn => btn.removeEventListener('click', this.cancel));
		this.cEntitySelectorMobile.off('change', this.onEntityChange);
		this.cEntitySelectorDesktop.off('change', this.onEntityChange);
		this.cProductSelectorMobile.off('change', this.onProductChange);
		this.cProductSelectorDesktop.off('change', this.onProductChange);
	}

	get entityType(){
		return this._entityType;
	}
	set entityType(entityType) {
		this._entityType = entityType;

		const {product}  = customization.products.get(entityType);
		const entities 	 = storage.getEntitiesByType(entityType, this.dependencyCode).filter(entity => customization.scene.entitiesIds.some(entityId => entityId.entity_id == entity.id));

		this.cEntitySelectorMobile.fill(entities)
		this.cEntitySelectorDesktop.fill(entities);

		this.cEntitySelectorDesktop.code 	= product.entity.code;
		this.cEntitySelectorMobile.code 	= product.entity.code;

		this.numberEntitiesMobile.innerHTML = entities.length;
		this.cEntitySelectorDesktop.resize();
	}

	edit(entityTypeCode, dependency = null){
		this.dependencyCode 	= dependency;
		this.entityType 		= entityTypeCode;

		return this.open();
	}

	open(){
		if(!this.visible){
			this.visible = true;

			this.element.style.display = "block";
			this.tuto.style.display = "block";

			var t = gsap.timeline();

			if(!this.viewport.medias.desktop){
				t.add(this.cHeader.hideButtonMenu(), 0);
			}

			t.add(this.cEntitySelectorDesktop.open(), 0);
			t.add(this.cProductSelectorDesktop.open(), 0);

			t.fromTo(this.bgGradient, {opacity:0}, {opacity:1, duration:0.5}, 0);
			t.to(this.contentDesktop, {background: 'rgba(128, 128, 128, 0.5)',duration: 0.4}, 0);

			t.fromTo(this.tuto, {opacity: 0}, {opacity: 1, duration:0.5}, 0.5);
			t.fromTo(this.tuto, {y: 40}, {y:0, duration:1, ease:'quint.out'}, 0.5);
			
			t.to(this.tuto, {opacity: 0, duration:0.4}, 2.5);
			t.to(this.tuto, {y: 80, duration: 0.5, ease:'quint.in'}, 2.5);
			t.to(this.contentDesktop, {background: 'rgba(0, 0, 0, 0)',duration: 0.4}, 2.5);

			t.add(this.cEntitySelectorMobile.open(), 2.5);
			t.add(this.cProductSelectorMobile.open(), 2.5);

			t.fromTo(this.estimation, {opacity: 0}, {opacity: 1, duration: 0.5}, 2.5);
			t.fromTo(this.available, {opacity: 0}, {opacity: 1, duration: 0.5}, 2.5);
			t.fromTo(this.validBtns, {opacity: 0}, {opacity: 1, duration: 0.5}, 2.5);

			t.add(() => {
				this.tuto.style.display = "none";
			})


			this.openTm = t;
		}

		return t;
	}
	close(){
		var t = gsap.timeline({delay:0.4});

		if(this.visible){
			this.visible = false;

			t.add(this.cEntitySelectorDesktop.close(), 0);
			t.add(this.cProductSelectorDesktop.close(), 0);
			t.add(this.cEntitySelectorMobile.close(), 0);
			t.add(this.cProductSelectorMobile.close(), 0);

			t.add(this.cHeader.showButtonMenu(), 0);

			t.to(this.validBtns, {opacity: 0, duration: 0.5}, 0);
			t.to(this.bgGradient, {opacity: 0, duration: 0.5}, 0);
			t.to(this.estimation, {opacity: 0, duration: 0.5}, 0);
			t.to(this.available, {opacity: 0, duration: 0.5}, 0);
			t.set(this.element, {display:'none'});
		}

		// this.currentEntity = null;
		// this.currentProduct = null;

		return t;
	}

	validate = () => {
		this.emit('apply', this.currentProduct)
	}

	cancel = () => {
		this.emit('cancel')
	}

	onEntityChange = async (entityCode) => {
		const t = gsap.timeline();

		if(this.entityChangeTm)
			this.entityChangeTm.kill();

		if(this.currentEntity != entityCode){

			const updateSelectors = () => {
				const products 	 = storage.entities.get(entityCode).products;
				const {product}  = customization.products.get(this.entityType);
			
				this.numberProductsMobile.innerHTML = products.length;
				
				this.cProductSelectorDesktop.fill(products);
				this.cProductSelectorMobile.fill(products);

				this.cProductSelectorDesktop.code = product.code;
				this.cProductSelectorMobile.code = product.code;

				this.cProductSelectorDesktop.resize();
			};

			if(this.visible){
				t.add(this.cProductSelectorDesktop.close(), 0);
				t.add(this.cProductSelectorMobile.close(), 0);
				t.add(updateSelectors);
			}
			else updateSelectors();

			this.currentEntity = entityCode
		}

		if(this.visible){
			t.add(() => {
				this.cProductSelectorDesktop.open();
				this.cProductSelectorMobile.open();
			});


			this.entityChangeTm = t;
		}

	}

	onProductChange = (productCode) => {
		if(this.currentProduct != productCode) {
			if(productCode != null){
				let qty = 1;

				const product = storage.products.get(productCode)
				if(this.dependencyCode){
					const dependency = storage.entities.get(this.dependencyCode)

					qty = dependency.dependencies.filter(dep => dep.code == product.entity.code).length
				}
				else{
					if(product.entity.entity_type_id == customization.floorTileId && product.entity.install_price.type == "m2"){
						qty = customization.scene.floor_tiling_qty;
					}
					else if(product.entity.entity_type_id == customization.wallTileId && product.entity.install_price.type == "m2"){
						qty = customization.scene.wall_tiling_qty;
					}
				}
				customization.set(productCode, qty, true);
				this.updateDependencies();
			}
			this.currentProduct = productCode
		}
	}

	updateDependencies(){
		const {product}  = customization.products.get(this.entityType);
		product.entity.dependencies_types.forEach(type => {
			const current = customization.products.get(type.code);
			const availables = storage.getEntitiesByType(type.code, product.entity.code);

			const available = availables.find(av => current.product.entity.code == av.code)

			if(!available && availables.length && availables[0].products.length){
				const qty = storage.dependenciesQuantities.get(`${product.entity.code}-${availables[0].code}`);
				customization.set(availables[0].products[0].code, qty, current.isUser);
			}
		})
	}
}